import React, { useEffect } from 'react';
import './RolesPermission.css';

const RolesPermission = ({ existingPermissions,setPermissions,permissions }) => {
 console.log("{ existingPermissions,setPermissions,permissions }", { existingPermissions,setPermissions,permissions })
  useEffect(() => {
    if (existingPermissions) {
      setPermissions(existingPermissions);
    }
  }, [existingPermissions, setPermissions]);
  const handleCheckboxChange = (category, permission) => {
    setPermissions((prevPermissions) => ({
        ...prevPermissions,
        [category]:{
          ...prevPermissions[category],
          [permission]:prevPermissions[category][permission]===null || prevPermissions[category][permission]===undefined
          ? null
          :!prevPermissions[category][permission],
        },
    }));
  };
  const capitalizeFirstLetter = (text) => {
    if(text==="apiDocumentation"){
      return 'API Documentation'
    }else{
    return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  };

  return (
    <form >
      <table className='sasp_common-table'style={{width:'100%'}}>
        <thead className='ant-table-thead'>
          <tr >
            <th className="font-face-vzw" style={{width:"25%"}}>Section</th>
            <th className="font-face-vzw">View</th>
            <th className="font-face-vzw">Create</th>
            <th className="font-face-vzw">Edit</th>
            <th className="font-face-vzw">Delete</th>
            <th className="font-face-vzw">Download</th>
            <th className="font-face-vzw">Configure</th>
          </tr>
        </thead>
        <tbody className='ant-table-tbody '>
          {Object.keys(permissions).map((category) => (
            <tr key={category}>
              <td style={{ fontWeight: "700", fontSize: "18px" }} >{capitalizeFirstLetter(category)}</td>
              {["view", "create", "edit", "delete", "download", "configure"].map((permission) => (
                <td key={permission}>
                    {permissions[category][permission] !==null && permissions[category][permission] !==undefined?(
                  <input
                    type="checkbox"
                    checked={permissions[category][permission]===true}
                    onChange={() => handleCheckboxChange(category, permission)}
                    style={{ accentColor: 'black' }}
                  />
                  ):('--')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </form>
  );
};

export default RolesPermission;